import type { PermittedLocation } from '@cfa/pathway-fe-shared/xp';

import Constants from '@/constants';

const LEADER_OR_ABOVE = new Set<string>([
  Constants.USER_ROLES.LEADER,
  Constants.USER_ROLES.OPERATOR,
  Constants.USER_ROLES.LICENSEESTAFF,
  Constants.USER_ROLES.STAKEHOLDER,
  Constants.USER_ROLES.ADMIN,
]);

/**
 * Plan owner eligibility via legacy leader-or-above roles.
 * `permissions.canCreatePlan` is not yet trusted in prod.
 */
export const isPlanOwnerEligible = (location: PermittedLocation) =>
  location.roles.some(role => LEADER_OR_ABOVE.has(role));
